import { Button, ButtonProps } from '@mui/material'
import { ActionRequest } from '../types'
import { useDialog } from '../hooks'
import { useTranslation } from 'react-i18next'
import ActionRequestDeviceLocationChangedDialog from './ActionRequestDeviceLocationChangedDialog'

interface ActionRequestDeviceLocationChangedButtonProps extends Omit<ButtonProps, 'children'> {
  actionRequest: ActionRequest
  afterAccept?: (actionRequest: ActionRequest) => void
  afterReject?: (actionRequest: ActionRequest) => void
}

export default function ActionRequestDeviceLocationChangedButton({
  actionRequest,
  afterAccept,
  afterReject,
  ...props
}: ActionRequestDeviceLocationChangedButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The dialog state.
   */
  const { open, openDialog, closeDialog } = useDialog()

  return (
    <>
      <Button {...props} onClick={openDialog}>
        {t('showLocation')}
      </Button>

      <ActionRequestDeviceLocationChangedDialog
        actionRequest={actionRequest}
        open={open}
        onClose={closeDialog}
        afterAccept={afterAccept}
        afterReject={afterReject}
      />
    </>
  )
}
